module.exports = __webpack_public_path__ + "img/header-other.d410324f.png";